import { apiGet, apiPost, apiPut, apiDelete } from "../../utils/apiHelpers";

// fetch framework
export const fetchTechstacks = async () => {
  try {
    let response = await apiGet(`/admin/techstacks`, {});

    if (response.error) {
      throw response.data.response.status === 500
        ? new Error("")
        : response.data;
    }
    return response.data.data;
  } catch (err) {
    throw err;
  }
};

export const fetchSingleTechstack = async (params) => {
  const [id] = params.queryKey;
  try {
    let response = await apiGet(`/admin/techstacks/${id}`, {});

    if (response.error) {
      throw response.data.response.status === 500
        ? new Error("")
        : response.data;
    }
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const createTechstack = async (formData) => {
  try {
    let response = await apiPost(`/admin/techstacks`, formData, {});

    if (response.error) {
      throw response.data.response.status === 500
        ? new Error("")
        : response.data;
    }
  } catch (err) {
    console.log({ err });
    throw err;
  }
};

export const editTechstack = async (data) => {
  try {
    let response = null;
    const { techstackId, payload } = data;
    if (data) {
      response = await apiPut(`/admin/techstacks/${techstackId}`, payload);
    }
    if (response.error) {
      throw response.data.response.status === 500
        ? new Error("")
        : response.data;
    }
  } catch (error) {
    console.log({ error });
    throw error;
  }
};

export const deleteTechstack = async (id) => {
  try {
    let response = await apiDelete(`/admin/techstacks/${id}`);
    if (response.error) {
      throw response.data.response.status === 500
        ? new Error("")
        : response.data;
    }
  } catch (err) {
    console.log({ err });
    throw err;
  }
};
